/* eslint-disable max-len */
import React, { useEffect, useState, Suspense, useContext } from 'react';
import CardHeader from '../../../../components/CardHeader';
import TopBarWithShadow from '../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../components/CustomOverlay';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { dataService } from '../../../../services/data.services';
import GlobalContext from '../../../../components/Context/GloablContext';
import { formatAdjustedDate, formatDateTime } from '../../../../CommonMethods/formatDate';
import Loader from '../../../../components/Loader';

const ItemsTable = React.lazy(() => import('./components/ItemsTable'));

const InvoiceDetails = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [viewInvoiceDetails, setViewInvoiceDetails] = useState({})
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext);

    const getViewInvoiceDetails = async () =>{
        try{
            let invoiceID = encodeURIComponent(id)
            setLoading(true)
            
            let endpoint = `invoice/details?_id=${invoiceID}`;
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data
            setViewInvoiceDetails(temp);
        } catch(error) {
            navigate('/404')
            console.log(error)
            setLoading(false)
        } finally{
            setLoading(false)
        }
    } 
    const handleDownload = async () => {
        try {
            let invoiceID = encodeURIComponent(id);
            setDownloadLoading(true);
            let endpoint = `invoice/details?_id=${invoiceID}&export=true`;
            const response = await dataService.GetAPI(endpoint);
            setToastmessage('Invoice downloaded successfully');
            window.open(response?.data?.data?.pre_signed_url);
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || 'Error downloading invoice');
            console.error('Error downloading invoice:', error);
        } finally {
            setDownloadLoading(false);
        }
    };

    

    useEffect(() => {
        getViewInvoiceDetails();
    }, []);

    
    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="Invoice Details"
                isback={true}
                backLocation={`/student-master/invoice-list?${searchParams.toString()}`}
                rightContent={
                    <button id='inv_download_btn' className={`view-actn-btn`} onClick={handleDownload} style={{'min-width': '110px'}}>
                        {downloadLoading ? <Loader colorCode='#106EB4'/> : "Download"}
                    </button>
                }
            />
            <Suspense fallback={<CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />}>
                {loading ? (
                    <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />
                ) : (
                    <div className="mainDataCntnrPageDiv scrollBlue_thick">
                        <div className="border rounded border-[#D0D5DD]  p-3 mb-6 2xl:w-[70%] xl:w-[85%] m-auto bg-white">
                            <div className="-mx-2 flex w-full">
                                <div className="w-[50%] px-2">
                                    <div className="flex mb-4 gap-6">
                                        <span className="w-[115px]" id='po_amount_label'>Student Name</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewInvoiceDetails.student_name}</span>
                                    </div>
                                    <div className="flex mb-4 gap-6">
                                        <span className="w-[115px]" id='po_amount_label'>Record ID</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewInvoiceDetails.student_id}</span>
                                    </div>
                                    <div className="flex mb-4 gap-6">
                                        <span className="w-[115px]" id='po_amount_label'>Invoice Amount</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewInvoiceDetails.invoice_amount}</span>
                                    </div>
                                    <div className="flex mb-4 gap-6">
                                        <span className="w-[115px]" id='po_amount_label'>Invoice Date</span>
                                        <span className="font-semibold break-all" id='po_amount'>{formatAdjustedDate(viewInvoiceDetails?.invoice_date) || '-'}</span>
                                    </div>
                                    <div className="flex gap-6">    
                                        <span className="w-[115px]" id='po_amount_label'>Added Date</span>
                                        <span className="font-semibold break-all" id='po_amount'>{formatDateTime(viewInvoiceDetails?.created_at) || '-'}</span>
                                    </div>
                                </div>
                                <div className="w-[50%] px-8">
                                    <div className="flex mb-4">
                                        <span className="w-[130px]" id='po_amount_label'>Invoice #</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewInvoiceDetails.invoice_number}</span>
                                    </div>
                                    <div className="flex mb-4">
                                        <span className="w-[130px]" id='po_amount_label'>Invoice Name</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewInvoiceDetails.invoice_name}</span>
                                    </div>
                                    <div className="flex mb-4">
                                        <span className="w-[130px]" id='po_amount_label'>Academic Year</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewInvoiceDetails.academic_year}</span>
                                    </div>
                                    <div className="flex mb-4">
                                        <span className="w-[130px]" id='po_amount_label'>Financial Year</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewInvoiceDetails.financial_year}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {viewInvoiceDetails.line_items?.length > 0 && (
                            <div className="mt-[30px]  2xl:w-[70%] xl:w-[85%] mx-auto">
                                <span className="font-semibold text-xl ml-[7px]">Items</span>
                                <ItemsTable items={viewInvoiceDetails.line_items} paymentDetails={viewInvoiceDetails.payment_details} total={viewInvoiceDetails.invoice_amount} balanceDue={viewInvoiceDetails.balance_due} invoiceType={viewInvoiceDetails?.invoice_type } />
                            </div>
                        )}
                    </div>
                )}
            </Suspense>
        </CardHeader>
    );
};

export default InvoiceDetails;